
export default class AudioToggle {

	constructor(node, callback) {
		this.node = node;
		this.callback = callback;
		this.button = node.querySelector('button');
		this.audio = node.querySelector('audio');
		this.isActive = false;
    	(this.button && this.audio) && this.addListener();
	}

	addListener() {
		this.toggleAudio = this.onToggle.bind(this);
		this.button.addEventListener('click', this.toggleAudio);
	}

	onToggle() {
		this.isActive = !this.isActive;
		this.audio.paused ? this.audio.play() : this.audio.pause();
		this.callback && this.callback({type: 'toggle', item: this});
	}

	destroy() {
		this.node.removeEventListener('click', this.toggleAudio);
	}

	static destroyAll() {
		AudioToggle.items.forEach((item) => {
			item.destroy();
		});
	}

	static init(context, callback) {
		const node = context ? context : document;
		AudioToggle.items = AudioToggle.from(node.querySelectorAll('[data-audio-toggle]')).map(node => {
			new AudioToggle(node, callback)
		})
	}
}
